export class OrganizationType {
  id: number;
  name: string;
  isAm?: boolean;
  hasSpecificTarget: boolean;
  visitClassSlot?: number;
  isHide?: boolean;
  parentId!: number;
  parentName: string;
  parentOrganozationType: any;
}
